module.exports = __webpack_public_path__ + "img/mg.67f5922d.svg";